module.exports = __webpack_public_path__ + "img/destination_mikumi_ln.172e661b.jpg";